import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import TrashcanIcon from '@wix/da-ds/pkg/Icons/24x24/Trashcan';
import useModule from '../../../../../hooks/useModule';
const RemoveButton = ({ moduleId, className, confirm, onRemove })=>{
    const { t } = useTranslation();
    const module = useModule(moduleId);
    return /*#__PURE__*/ React.createElement(SimpleTooltip, {
        usePortal: true,
        text: t('gruser.widgetbox.button.remove')
    }, /*#__PURE__*/ React.createElement(IconButton, {
        icon: TrashcanIcon,
        variant: "edit-purple",
        size: "medium",
        onClick: confirm ? ()=>confirm(onRemove, BiData({
                evid: 270,
                // can't use BiContextProvidedValue because confirmation modal won't have the context
                widgetname: module === null || module === void 0 ? void 0 : module.name,
                widgetzone: module === null || module === void 0 ? void 0 : module.zonename
            })) : onRemove,
        className: className,
        "data-role": "edit-control",
        biData: BiData({
            evid: 280,
            widgetname: BiContextProvidedValue,
            widgetzone: BiContextProvidedValue
        }),
        "aria-label": t('gruser.widgetbox.button.remove')
    }));
};
RemoveButton.displayName = 'RemoveButton';
export default RemoveButton;
